import { render } from "./AcademicWeekdaySecondary.vue?vue&type=template&id=e7d7f3b6&scoped=true"
import script from "./AcademicWeekdaySecondary.vue?vue&type=script&lang=js"
export * from "./AcademicWeekdaySecondary.vue?vue&type=script&lang=js"

import "./AcademicWeekdaySecondary.vue?vue&type=style&index=0&id=e7d7f3b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d7f3b6"]])

export default __exports__